import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';

/**
 * Service for entity details tab.
 */
@Injectable()
export class EntityDetailsService {
    entityDetailsUpdated: EventEmitter<EntityIdDetails> = new EventEmitter();
    private entityIdDetails: EntityIdDetails;

    constructor(private requestService: ObservableRequestService) {
        this.entityIdDetails = new EntityIdDetails();
    }

    setEntityIdDetails(entityIdDetails: EntityIdDetails): void {
        this.entityIdDetails = entityIdDetails;
        this.entityDetailsUpdated.emit(this.entityIdDetails);
    }

    getEntityIdDetails(): EntityIdDetails {
        return this.entityIdDetails;
    }

}



// WEBPACK FOOTER //
// ./src/app/entities/details/entity-details.service.ts